import request from '@/utils/request'

// 反馈意见
export function inputfeedbackOpinion(opinion) {
  return request({
    url: '/feedback/saveFeedback.do',
    method: 'post',
    data: opinion
  })
}
// 反馈意见列表
export function queryFeedback(opinion) {
  return request({
    url: '/feedback/queryFeedback.do',
    method: 'post',
    data: opinion
  })
}



// WEBPACK FOOTER //
// ./src/api/feedbackOpinion.js